import { Component, computed, input } from '@angular/core';

import type { SubmenuLI } from '../../../../../types/menu-li';

@Component({
  imports: [],
  selector: 'app-submenu',
  templateUrl: './submenu.html',
})
export class Submenu {
  public readonly menuItems = input.required<SubmenuLI[]>();

  protected readonly visibleMenuItems = computed(() =>
    this.menuItems().filter((i) => i.showOnDesktop),
  );
}
